import React, { useContext } from "react";
import { createPortal } from "react-dom";
import { ProductContext } from "../provider";
import globalComp from "../../../global/components";
import { AppContext } from "../../../provider/AppProvider";

interface Props {}

function Extra_Prd({}: Props): JSX.Element {
  let t = window.INITIAL_DATA.TRANSLATIONS;
  const { productPreview } = useContext(AppContext);
  const { isExtraProductSelected, setIsExtraProductSelected } = useContext(
    ProductContext
  );
  return createPortal(
    <>
      {!productPreview && (
        <div className={"px-2 mt-3 mt-md-4"}>
          <globalComp.FieldHeader
            number={5}
            title={t.special_offer}
            tooltipStr={t.tooltip_special_offer}
            clearAfter={true}
            extraCssClass={"pb-2"}
            element={
              <div
                className={
                  "d-flex flex-wrap justify-content-center justify-content-md-start"
                }>
                <p className={"w-100 font-weight-bold m-0 h3 mb-1"}>
                  {window.INITIAL_DATA.extraProduct.title}
                </p>
                <p className={"w-100"}>
                  {window.INITIAL_DATA.extraProduct.description}
                </p>
                <ExtraComponent
                  imgUrl={window.INITIAL_DATA.extraProduct.thumbnail}
                  isChecked={isExtraProductSelected}
                  onClick={() =>
                    setIsExtraProductSelected(!isExtraProductSelected)
                  }
                />
              </div>
            }
          />
        </div>
      )}
    </>,
    document.getElementById("extra-product-container")
  );
}

export default Extra_Prd;

function ExtraComponent({ imgUrl, isChecked, onClick }: any): JSX.Element {
  return (
    <div className={"pr-3"}>
      <div
        className={`btn btn-light position-relative custom-checkbox-v3 ${
          isChecked ? "border-primary" : ""
        }`}
        onClick={onClick}>
        <img
          src={imgUrl}
          className={"custom-checkbox-v3-img"}
          alt="product-photo"
        />
        {isChecked && (
          <p className={"border-primary custom-checkbox-v3-checkmark"}>
            &#10003;
          </p>
        )}
      </div>
    </div>
  );
}
